import React from "react"

import {Deal} from "@irati/types"
import {Hr} from "@irati/ui/src/Layout"
import FormattedMessage from "@irati/utils/lang"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"
import {H4} from "@irati/ui/src/Typography"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import ReadMore from "../../ReadMore"

interface Props extends WithPerkOrReward {
  id?: string
  deal: Deal
}

const DealDescription: React.FC<Props> = ({deal, isRewards}) => {
  if (!deal.description) return null
  const isCompanyBenefit = deal.type === DEAL_TYPE_COMPANY_BENEFITS
  let key = "perks.components.dealInfoBlock.dealDescription.perkDesc"
  if (isCompanyBenefit) {
    key = "perks.components.dealInfoBlock.dealDescription.benefitDesc"
  }
  if (isRewards) {
    key = "perks.components.dealInfoBlock.dealDescription.rewardDesc"
  }

  return (
    <section>
      <Hr />
      <H4 marginBottom={2}>
        <FormattedMessage id={key} />
      </H4>
      <ReadMore maxHeightPx={48}>{deal.description}</ReadMore>
    </section>
  )
}

export default withPerkOrReward(DealDescription)
